// @ts-nocheck

(function initHomeScrollRestore() {
  const STORAGE_KEY = 'ocs:home-scroll-restore';
  const MAX_AGE_MS = 30 * 60 * 1000;
  const RESTORE_DELAYS_MS = [0, 50, 100, 250, 500, 1000, 2000];

  if (!window.matchMedia('(max-width: 749px)').matches) return;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function navigationIsBackForward(event) {
    if (event?.persisted) return true;
    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    return navigation?.type === 'back_forward';
  }

  function readState() {
    try {
      const state = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!state || state.url !== window.location.href) return null;
      if (Date.now() - state.timestamp > MAX_AGE_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return state;
    } catch (_) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function matchingLinks(href) {
    return [...document.querySelectorAll('a[href]')].filter((link) => link.href === href);
  }

  function saveState(link) {
    const canAnchorToLink = Boolean(link.closest('#MainContent'));
    const matches = canAnchorToLink ? matchingLinks(link.href) : [];
    const linkIndex = matches.indexOf(link);

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          url: window.location.href,
          scrollX: Math.round(window.scrollX || 0),
          scrollY: Math.round(window.scrollY || document.documentElement.scrollTop || 0),
          anchorHref: canAnchorToLink ? link.href : '',
          anchorIndex: Math.max(0, linkIndex),
          anchorTop: canAnchorToLink ? link.getBoundingClientRect().top : null,
          timestamp: Date.now(),
        }),
      );
    } catch (_) {}
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest?.('a[href]');
      if (!link || link.download || (link.target && link.target !== '_self')) return;

      const destination = new URL(link.href, window.location.href);
      if (!['http:', 'https:'].includes(destination.protocol) || destination.href === window.location.href) return;

      saveState(link);
    },
    true,
  );

  function restore(event) {
    if (!navigationIsBackForward(event)) return;

    const state = readState();
    if (!state) return;

    let cancelled = false;
    const cancel = () => {
      cancelled = true;
      sessionStorage.removeItem(STORAGE_KEY);
    };
    const cancelEvents = ['touchstart', 'wheel', 'keydown'];

    for (const eventName of cancelEvents) {
      window.addEventListener(eventName, cancel, { once: true, passive: true });
    }

    const apply = () => {
      if (cancelled) return;

      const anchor = matchingLinks(state.anchorHref)[state.anchorIndex];
      const top = anchor
        ? window.scrollY + anchor.getBoundingClientRect().top - state.anchorTop
        : state.scrollY;

      window.scrollTo(state.scrollX || 0, Math.max(0, Math.round(top)));
    };

    for (const delay of RESTORE_DELAYS_MS) {
      window.setTimeout(apply, delay);
    }

    Promise.resolve(document.fonts?.ready).then(apply).catch(() => {});

    window.setTimeout(() => {
      if (!cancelled) sessionStorage.removeItem(STORAGE_KEY);
      for (const eventName of cancelEvents) {
        window.removeEventListener(eventName, cancel);
      }
    }, RESTORE_DELAYS_MS[RESTORE_DELAYS_MS.length - 1] + 100);
  }

  window.addEventListener('pageshow', restore);
  restore();
})();
